<template>
  <div class="content-box">
    <el-image src="/static/imgs/rz.png" fit="cover" class="saveimg w-img" />
    <div class="zhanshi">

      <div class="zhanshi-box">
        <div class="zs-tit dis">
          <div class="z-div"> </div>
          <div>入驻商家享受权益</div>
          <div class="z-div"></div>
        </div>

        <div class="zs-list over">
          <div class="zs-list-c">
            <el-image src="/static/imgs/fs.png" fit="cover" style="width: 200px;height: 200px;" />
            <p class="zs-p1">多种交易方式</p>
            <p class="zs-p2 clamp2">集采，竞价交易，撮合交易 多种方式，保证成本的优势</p>
          </div>
          <div class="zs-list-c">
            <el-image src="/static/imgs/sx.png" fit="cover" style="width: 200px;height: 200px;" />
            <p class="zs-p1">可视化交易</p>
            <p class="zs-p2 clamp2">全过程进度展示，生产质检装 车全流程可视化</p>
          </div>
          <div class="zs-list-c" style="margin-right: 0;">
            <el-image src="/static/imgs/fz.png" fit="cover" style="width: 200px;height: 200px;" />
            <p class="zs-p1">质量标准</p>
            <p class="zs-p2 clamp2">开创行业先河以明确质量标准 交易并提供质量检验保证服务</p>
          </div>
          <div class="zs-list-c">
            <el-image src="/static/imgs/fl.png" fit="cover" style="width: 200px;height: 200px;" />
            <p class="zs-p1">法律支持</p>
            <p class="zs-p2 clamp2">规范可靠的交易，全程法律支 持服务，质量资金安全有保障</p>
          </div>
          <div class="zs-list-c">
            <el-image src="/static/imgs/zxs.png" fit="cover" style="width: 200px;height: 200px;" />
            <p class="zs-p1">行情咨讯</p>
            <p class="zs-p2 clamp2">聚焦行业动态，汇聚业态热点 行情准确，资讯丰富</p>
          </div>
          <div class="zs-list-c" style="margin-right: 0;">
            <el-image src="/static/imgs/sh.png" fit="cover" style="width: 200px;height: 200px;" />
            <p class="zs-p1">售后服务</p>
            <p class="zs-p2 clamp2">专业客服团队，适时提供专业 服务</p>
          </div>
        </div>






      </div>
    </div>

    <div class="ruzu-box ">
      <div class="ruzu dis">
        <div class="dis">
          <el-image src="/static/imgs/fj.png" fit="cover" style="width: 72px;height: 72px;padding-right: 24px;" />
          <p class="rz-p">快速对接入驻经理，帮你马上入驻</p>
        </div>
        <div class="dis">
          <div class="rz-input">
            <input v-model="input" placeholder="请留下您的联系方式" class="inp-bor" />
          </div>
          <div class="rz-btn cupo" @click="ruzhu">
            立即入驻
          </div>
        </div>
      </div>
    </div>


    <div class="tan-show" v-if="tanShow">
      <p class="tan-show-p1">入驻提醒</p>
      <p class="tan-show-p2">我们将在1个工作日内为您对接入驻经理，您也可以拨打联系电话180-8672-7328 快速办理入驻</p>
      <p class="tan-show-p3 cupo" @click="tanShow = false">我知道了</p>
    </div>

  </div>
</template>

<script>
  export default {

    data() {
      return {
        input: '',
        tanShow: false
      }
    },

    methods: {
      ruzhu() {
        if (!this.input) {
          this.$notify.error({
            title: '错误',
            message: '请输入手机号！',
            position: 'top-left'
          });
          return
        }
        if (!this.validatePhoneNumber(this.input)) {

          this.$notify.error({
            title: '错误',
            message: '手机号码格式不正确 请重试！',
            position: 'top-left'
          });
          return
        }
        this.$request('post', this.$wxapi + 'website/savePhone', {
          phone: this.input
        }, (res) => {
          if (res.status == 200) {
            this.tanShow = true
            this.input = ''
          } else {
            this.$notify.error({
              title: '错误',
              message: res.msg,
              position: 'top-left'
            });
          }
        })
      },
      validatePhoneNumber(phone) {
        const regex = /^1[3-9]\d{9}$/;
        return regex.test(phone);
      }

    },
    metaInfo() {
      return {
        title: '聚木网-商家入驻'
      }
    }
  }
</script>

<style scoped>
  .content-box {
    position: relative;
  }

  .zhanshi {
    background: #fff;
    width: 100%;

  }

  .zhanshi-box {
    width: 1200px;
    margin: 0 auto;
  }

  .zs-tit {
    width: 298px;
    height: 36px;
    line-height: 36px;
    margin: 0 auto;
    padding: 30px 0;
    font-weight: bold;
    font-size: 24px;
    color: #37393F;
  }

  .z-div {
    width: 16px;
    height: 16px;
    background: #37393F;
    transform: rotate(45deg);
  }

  .zs-list-c {
    float: left;
    margin-right: 210px;
    width: 260px;
    margin-bottom: 60px;
    text-align: center;
  }

  .zs-p1 {
    font-weight: bold;
    font-size: 24px;
    color: #37393F;
    margin: 24px 0;
  }

  .zs-p2 {
    width: 100%;
    font-weight: 400;
    font-size: 20px;
    color: #7D7D7D;
    text-align: left;
  }

  .ruzu-box {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: hsla(0, 0%, 100%, .9);
    z-index: 10;
    box-shadow: 0 -2px 5ch -2px rgb(0 0 0 / 30%);
  }

  .ruzu {
    width: 1200px;
    margin: 24px auto;


  }

  .rz-p {
    font-weight: bold;
    font-size: 32px;
    color: #37393F;
  }

  .rz-input {
    width: 400px;
    height: 60px;
    background: #FFFFFF;
    border-radius: 10px;
    border: 3px solid #2468F2;
    margin-right: 14px;
  }

  .rz-btn {
    width: 140px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    background: #2468F2;
    border-radius: 10px;
    border: 1px solid #2468F2;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
  }

  .inp-bor {
    border: none !important;
    display: block;
    width: 88%;
    margin: 0 auto;
    height: 90%;
    margin-top: 0.5%;


  }
  .input{
    font-size: 18px;
  }

  input:focus {
    outline: none;
    /* 去掉聚焦时的默认外轮廓 */
  }


  input::placeholder {
    color: #B9B9B9;
    font-size: 18px;
    /* 设置 placeholder 字体颜色 */
  }

  .tan-show {
    width: 733px;
    height: 525px;
    background: url('../../static/imgs/rzbg.png') no-repeat center center;
    background-size: 100%;
    position: fixed;
    top: 50%;
    z-index: 2;
    /* 距离父元素顶部 50% */
    left: 50%;
    border-radius: 15px;
    transform: translate(-50%, -50%);
    text-align: center;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  }

  .tan-show-p1 {
    font-weight: bold;
    font-size: 24px;
    color: #37393F;
    margin: 263px 0 15px 0;
  }

  .tan-show-p2 {
    font-weight: bold;
    font-size: 16px;
    color: #37393F;
    margin: 0 auto 58px auto;
    width: 581px;
    line-height: 24px;
    text-align: left;
  }

  .tan-show-p3 {
    width: 140px;
    height: 50px;
    background: #2F7BFF;
    border-radius: 12px;
    margin: 0 auto;
    text-align: center;
    line-height: 50px;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/settled.vue